import styled, { css, device, themeGet } from '@styled'

export const TeamWrapper = styled.section`
  padding-block-start: 53px;
  ${device.medium} {
    padding-block-start: 72px;
  }
  ${device.large} {
    padding-block-start: 89px;
  }
  scroll-margin-top: 50px;
`

export const TeamWrapperInternal = styled.section`
  ${(props) =>
    props.index === 0 &&
    css`
      ${device.small} {
        padding-block-start: 72px;
      }
      ${device.medium} {
        padding-block-start: 0px;
      }
      ${device.large} {
        padding-block-start: 0px;
      }
    `}
`

export const CenteredBorder = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  padding-right: 0px;
  padding-left: 0px;
  left: 50%;
  width: 1px;
  background-color: lightgrey;
  transform: translateX(-51%) scale(1, 1.01);
`

export const StyledTitle = styled.h3`
  ${({ $layout }) =>
    $layout === 2 &&
    css`
      margin-block-end: 10px;
      ${device.medium} {
        margin-block-end: 20px;
      }
    `}
  span {
    color: ${themeGet('colors.primary')};
  }
`
